module.exports = __webpack_public_path__ + "static/media/verdana-negrita.215accaa.ttf";